import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Rocket, GraduationCap, BookOpen, Trophy, ArrowRight, CheckCircle2, Lock } from 'lucide-react'
import api from '../api/client'
import { useAuth } from '../auth'

const LIBERA = [
  'Cadastro de Clientes e Nova Conexão',
  'Cotações e Proteção Veicular',
  'Minha Rede e Plano de Comissões',
  'Carteira, Extrato e Saques',
  'Link de Recrutamento e Campanhas premiadas',
]
const CONHECA = [
  { icon: GraduationCap, titulo: 'Universidade Corporativa', desc: 'Plano de negócios e treinamentos', to: '/universidade' },
  { icon: BookOpen, titulo: 'Materiais de Apoio', desc: 'Vídeos e materiais para começar', to: '/material' },
  { icon: Trophy, titulo: 'Campanhas', desc: 'Veja as campanhas e o ranking', to: '/incentivos' },
]

// Dashboard de APRESENTAÇÃO para o PRÉ-LICENCIADO (licença pendente) — PRD.
export default function DashboardApresentacao() {
  const nav = useNavigate()
  const { user, licenciado } = useAuth()
  const [loading, setLoading] = useState(false)
  const nome = (user?.nome || licenciado?.nome || '').split(' ')[0]

  async function finalizar() {
    setLoading(true)
    try {
      const { data } = await api.post('/conta/licenca/checkout')
      const url = (data?.checkout_url || '').replace(/^\/#/, '')
      nav(url || '/minha-conta')
    } catch { nav('/minha-conta') } finally { setLoading(false) }
  }

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      {/* Hero */}
      <div className="rounded-2xl overflow-hidden shadow-sm border border-neutral-200">
        <div className="p-6 sm:p-8 text-graphite" style={{ background: 'linear-gradient(135deg, #ffcc00 0%, #ff9d33 55%, #ff6c00 100%)' }}>
          <div className="flex items-center gap-2 mb-2">
            <Rocket size={22} /> <span className="text-xs font-bold uppercase tracking-wider bg-white/40 rounded-full px-3 py-1">Pré-Licenciado</span>
          </div>
          <h1 className="text-2xl sm:text-3xl font-heading font-extrabold">Bem-vindo(a){nome ? `, ${nome}` : ''}!</h1>
          <p className="text-graphite/80 mt-1 max-w-xl">
            Seu acesso está criado. Ative sua licença para desbloquear toda a plataforma e começar a construir sua rede.
          </p>
          <button onClick={finalizar} disabled={loading}
            className="mt-5 inline-flex items-center gap-2 bg-graphite text-white font-bold rounded-xl px-6 py-3 hover:brightness-125 transition disabled:opacity-60">
            {loading ? 'Abrindo pagamento...' : 'Finalizar Pagamento da Licença'} <ArrowRight size={16} />
          </button>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {/* O que será liberado */}
        <div className="bg-white rounded-2xl border border-neutral-200 shadow-sm p-6">
          <div className="flex items-center gap-2 mb-3">
            <Lock size={18} className="text-accent-500" />
            <h2 className="font-heading font-bold text-graphite">Você desbloqueia ao ativar</h2>
          </div>
          <ul className="space-y-2">
            {LIBERA.map((t) => (
              <li key={t} className="flex items-start gap-2 text-sm text-neutral-700">
                <CheckCircle2 size={16} className="text-emerald-500 flex-shrink-0 mt-0.5" /> {t}
              </li>
            ))}
          </ul>
        </div>

        {/* Conheça enquanto isso */}
        <div className="bg-white rounded-2xl border border-neutral-200 shadow-sm p-6">
          <h2 className="font-heading font-bold text-graphite mb-3">Enquanto isso, explore</h2>
          <div className="space-y-2">
            {CONHECA.map((c) => (
              <button key={c.to} onClick={() => nav(c.to)}
                className="w-full flex items-center gap-3 text-left rounded-xl border border-neutral-200 p-3 hover:border-accent-300 hover:bg-accent-50/40 transition">
                <div className="w-10 h-10 rounded-lg bg-accent-50 border border-accent-100 flex items-center justify-center flex-shrink-0">
                  <c.icon size={18} className="text-accent-500" />
                </div>
                <div className="flex-1">
                  <p className="font-semibold text-graphite text-sm">{c.titulo}</p>
                  <p className="text-xs text-neutral-500">{c.desc}</p>
                </div>
                <ArrowRight size={16} className="text-neutral-400" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
